import { Modal } from '@shop/frontend/web/js/components/Modal';
import { translator } from '@shop/frontend/web/js/services/TranslatorService';
import { helpers } from '@shop/frontend/web/js/helpers';
import api from '@shop/frontend/web/js/api';

export class EventView {
  constructor() {
    this.$popupModal = null;
    this.$placesContainer = $('#js-places');
    this.$popupInfoBlocks = null;
    this.modal = new Modal({ className: 'i-modal_mobile-fixed', id: 'popup-event' });
    this.childAlert = new Modal({ className: 'i-modal_alert', id: 'child-modal' });
    this.modalInfoBlocks = new Modal({ className: 'i-modal__info-blocks', id: 'info-blocks-modal' });
  }

  getPlacesSettings() {
    const settings = {};

    if (this.$placesContainer.attr('data-show-free-places') === '0') settings.showFreePlaces = false;
    if (this.$placesContainer.attr('data-price-filter-type')) {
      settings.planPriceFilterType = parseInt(
        this.$placesContainer.attr('data-price-filter-type'),
      );
    }
    if (this.$placesContainer.attr('data-has-child-ticket') === 'true') settings.hasChildTicket = true;

    return settings;
  }

  showEventOnPopup() {
    const places = $('#js-places');
    const htmlObject = document.createElement('div');
    htmlObject.innerHTML = places.appendTo('<div></div>').html();
    this.modal.show(htmlObject);
    this.$popupModal = $('.i-modal_mobile-fixed');
    this.$popupModal.find('.places__content').wrap("<div id='js-places'></div>");
    this.$popupModal.find('.places__top').show();

    this.$popupModal.find('.places__middle').append($('.js-stadium-zones'));
    this.$popupModal.find('.places__middle').prepend($('#js-fan-id-alert'));
    this.$popupModal.find('.places__middle').append($('.js-places-prices'));
    const closeButton = this.$popupModal.find('.i-modal__close');

    closeButton.removeAttr('data-bs-dismiss');
    closeButton.on('click', () => {
      window.location.assign('/');
    });

    this.$popupInfoBlocks = $('.i-modal__info-blocks');
    const closeButtonInfoBlocks = this.$popupInfoBlocks.find('.i-modal__close');
    closeButtonInfoBlocks.removeAttr('data-bs-dismiss');
    closeButtonInfoBlocks.on('click', () => {
      this.$popupInfoBlocks.modal('hide');
      this.$popupModal.modal('show');
    });
  }

  returnEventFromPopup() {
    $('.events_page').after($('#js-places'));

    $('#js-places-check-price').after($('.js-stadium-zones'));
    $('#js-places-check-price').after($('.js-places-prices'));

    $('.places__top').hide();
    this.$popupModal.find('.modal-body').html('');
    this.$popupModal.removeClass('i-modal_mobile-fixed');
    this.$popupModal.modal('hide');
  }

  getPopupSettings() {
    const id = document.location.href
      .match(/id_event=([0-9]+)/g)[0]
      .match(/[0-9]/g)
      .join('');

    return api.event.getPopupSettings(id);
  }

  showChildTicketInfo() {
    if (document.location.href.includes('event')) {
      this.getPopupSettings()
        .then((res) => {
          if (!localStorage.getItem('change_price_id_alert') && res.presence) {
            const isSeason = $('.events_page').data('is-season');
            const word = isSeason ? 'абонемент' : 'билет';
            const text = res.messages[0];
            this.childAlert.show(
              `
            <h3>${translator.t('event', 'Note!')}</h3>
            <p class="mb-0">${text}</p>
            <label class="checkbox mt-4 mb-4 d-inline-flex">
            <input type="checkbox" name="show_price_id_alert_discount" class="checkbox__input" checked />
            <span class="checkbox__custom"></span>
            <span class="checkbox__block">${translator.t('event', "Don't show this message")}</span>
            </label>
            <br>
            <button class="btn js-price-id-alert-btn" data-bs-dismiss="modal">${translator.t(
              'event',
              'Continue',
            )}</button>
          `,
          );

            $('.js-price-id-alert-btn').on('click', () => {
              if ($("input[name='show_price_id_alert_discount']").is(':checked')) {
                localStorage.setItem('change_price_id_alert', 'true');
              }
            });
          }
        })
        .catch((err) => console.log(err));
    }
  }

  setSwiperBlocksWidth() {
    const swiper = !helpers.isDesktop.matches ? $('.swiper-mobile') : $('.swiper');
    const slides = swiper.find('.swiper-slide');
    const count = slides.length;

    switch (count) {
      case 1:
        $(slides).each((index, slide) => {
          $(slide).addClass('swiper_one-slide');
        });
        break;
      case 2:
        $(slides).each((index, slide) => {
          $(slide).addClass('swiper_two-slides');
        });
        break;
      default:
        $(slides).each((index, slide) => {
          $(slide).addClass('swiper_three-slides');
        });
    }
  }
}
